import { Spin } from 'antd';
import React from 'react';
import styled from 'styled-components';
import themeStore from 'store/theme';

interface IProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  icon?: React.ReactNode;
  name?: string;
  status?: 'success' | 'error' | 'normal' | 'disabled' | 'unimportant';
  textColor?: string;
  bgColor?: string;
  loading?: boolean;
  height?: number;
  width?: number;
}

const VButton = (props: IProps) => {
  const {
    icon,
    name,
    status = 'normal',
    height = 44,
    width,
    loading = false,
    textColor,
    bgColor,
    disabled = false,
    ref,
    ...rest
  } = props;
  const getColor = () => {
    if (disabled) {
      return {
        text: '#fff',
        bg: '#CDCDCD',
      };
    }
    switch (status) {
      case 'success':
        return {
          text: '#fff',
          hover: themeStore.getData().primaryLightColor,
          bg: themeStore.getData().primaryColor,
        };
      case 'error':
        return {
          text: '#fff',
          bg: '#DE5753',
        };
      case 'disabled':
        return {
          text: '#fff',
          bg: '#CDCDCD',
        };
      case 'unimportant':
        return {
          text: '#9EA4B0',
          bg: '#fff',
        };
      default:
        return {
          text: themeStore.getPrimaryColor(),
          bg: '#fff',
        };
    }
  };

  return (
    <ButtonWrapper
      className="v-btn-wrapper"
      textcolor={getColor().text}
      disabled={props.disabled || loading || status === 'disabled'}
      bgcolor={getColor().bg}
      width={width}
      height={height}
      {...rest}
    >
      {props.children ? (
        <div className="v-btn v-btn-center">
          {props.children}
          {loading && <Spin size="small" className="loading-icon"></Spin>}
        </div>
      ) : (
        <div className="v-btn">
          <div className="v-btn__icon">{icon}</div>
          <div className="v-btn__name">{name}</div>
          {loading && <Spin size="small" className="loading-icon"></Spin>}
        </div>
      )}
    </ButtonWrapper>
  );
};

export default VButton;

const ButtonWrapper = styled.button<{
  width: number | undefined;
  height: number;
  textcolor: string;
  bgcolor: string;
  disabled: boolean;
}>`
  outline: 0;
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  height: ${(props) => `${props.height}px`};
  padding: 0;
  font-size: 16px;
  font-family: VFont, Arial;
  border-radius: 4px;
  background: ${(props) => props.bgcolor};
  color: ${(props) => props.textcolor};
  border: 1px solid ${(props) => (props.bgcolor !== '#fff' ? props.bgcolor : props.textcolor)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: 0.2s linear all;
  &:hover {
    background: ${(props) =>
      props.bgcolor !== '#fff' ? props.bgcolor : props.theme.primaryFocusColor};
    color: ${(props) => props.textcolor};
    cursor: pointer;
  }
  .v-btn {
    display: flex;
    align-items: center;
    &-center {
      justify-content: center;
    }
    &__icon {
      padding: 0 9px 0 18px;
      svg {
        vertical-align: middle;
        fill: ${(props) => props.textcolor};
      }
    }
    &__name {
      line-height: 32px;
      font-size: 12px;
      letter-spacing: 0;
    }
  }
  .loading-icon {
    margin-left: 6px;
    i {
      background: ${(props) => props.textcolor};
    }
  }
`;
